// extracted by mini-css-extract-plugin
export default {"container":"NoData_container__qK5GX","title":"NoData_title__NSAaX"};